import React, { CSSProperties } from 'react';
import { Tooltip } from 'antd';
import { useMediaStreamMetrics } from 'amazon-chime-sdk-component-library-react';
import { PiCellSignalSlashBold, PiCellSignalMediumBold, PiCellSignalFullBold } from 'react-icons/pi';

type MediaStreamMetrics = ReturnType<typeof useMediaStreamMetrics>;

const ChimeSignalStrengthIndicator = ({
  strength,
  metrics,
  style = {}
}: {
  strength: number | boolean;
  metrics?: MediaStreamMetrics;
  style?: CSSProperties;
}) => {
  let indicator = null;
  const videoStreamMetrics = Object.values(Object.values(metrics?.videoStreamMetrics || {})?.[0] || {})?.[0];
  const StreamMetrics = [
    `Audio Speaker Delay: ${metrics?.audioSpeakerDelayMs?.toFixed(0)} Ms`,
    `Audio Downstream Jitter: ${metrics?.audioDownstreamJitterMs?.toFixed(0)} Ms`,
    `Current Round Trip Time: ${metrics?.currentRoundTripTimeMs?.toFixed(0)} Ms`,
    `Video Upstream Packet Loss Percent: ${videoStreamMetrics?.videoUpstreamPacketLossPercent?.toFixed(2)}%`,
    `Video Upstream Round Trip Time: ${videoStreamMetrics?.videoUpstreamRoundTripTimeMs?.toFixed(0)} Ms`,
    `Video Upstream Jitter: ${videoStreamMetrics?.videoUpstreamJitterMs?.toFixed(0)} Ms`
  ];
  if (strength === 0) {
    indicator = <PiCellSignalSlashBold style={style} size={32} />;
  }

  if (strength === 0.5) {
    indicator = <PiCellSignalMediumBold style={style} size={32} />;
  }

  if (strength === 1) {
    indicator = <PiCellSignalFullBold style={style} size={32} />;
  }

  if (!metrics) return indicator;
  return (
    <Tooltip
      title={
        <ul>
          {StreamMetrics?.map((el) => (
            <li key={el} style={{ fontSize: 10 }}>
              {el}
            </li>
          ))}
        </ul>
      }
      trigger={['hover', 'focus']}
    >
      {indicator}
    </Tooltip>
  );
};

export default ChimeSignalStrengthIndicator;
